export default __webpack_public_path__ + "static/home_developers_bg-ed1f22888b2351fbb3df776e9b03b9f4.png";